import { BaseService } from "services/_baseService";


class RoomsService extends BaseService<any> {
  constructor() {
    super("rooms");
  }
}
export default new RoomsService();
